export const listBarnsWithOnlyBasicDetails = /* GraphQL */ `
  query ListBarns(
    $id: ID
    $filter: ModelBarnFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listBarns(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        contact {
          id
          work
          website
        }
        ownerName
        ownerPersonId
        location {
          id
          streetAddress1
          streetAddress2
          city
          provState
          zip
          country
        }
        createdOn
        updatedOn
        barnContactId
        barnLocationId
      }
      nextToken
    }
  }
`;